import React from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { changeColorMode } from '../helpers/helpers'

import logoDelijn from '../assets/images/logo.svg'
import logoDelijnWhite from '../assets/images/logo-white.png'

import {
  HeaderContainer,
  LogoAndTimeWrapper,
  StyledLogo,
  PassagesText,
  CurrenTimeSpan,
  DepartureTitle,
  LoadingBorder,
  TimeSeparator,
} from './Header.styles'

import { primaryTextColor } from '../helpers/helpers'
import { format } from 'date-fns'
import { DEPARTURE, NO_PASSAGES } from '../constants/index'

function PassagesHeader({ currentTime, error, hasLines }) {
  const queryParam = queryString.parse(window.location.search)
  const lightMode = changeColorMode(queryParam.inverse)
  const minutes = format(currentTime || 1, 'HH')
  const secondes = format(currentTime || 1, 'mm')

  return (
    <>
      <HeaderContainer light={lightMode}>
        <LogoAndTimeWrapper>
          <StyledLogo
            light={lightMode}
            src={lightMode ? logoDelijn : logoDelijnWhite}
          />
          {error || !hasLines ? (
            <PassagesText color={primaryTextColor(queryParam)}>
              {NO_PASSAGES}
            </PassagesText>
          ) : (
            <CurrenTimeSpan light={lightMode}>
              {minutes}
              <TimeSeparator>:</TimeSeparator>
              {secondes}
            </CurrenTimeSpan>
          )}
        </LogoAndTimeWrapper>
        {hasLines && (
          <DepartureTitle light={lightMode}>{DEPARTURE}</DepartureTitle>
        )}
      </HeaderContainer>
      <LoadingBorder light={lightMode} />
    </>
  )
}

PassagesHeader.propTypes = {
  currentTime: PropTypes.number,
  error: PropTypes.bool,
  hasLines: PropTypes.bool,
}

export default PassagesHeader
